import { render, staticRenderFns } from "./CreateComment.vue?vue&type=template&id=c93fb198&"
import script from "./CreateComment.vue?vue&type=script&lang=js&"
export * from "./CreateComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports